
<button class="button" (click)="handleClick()" [matTooltip]="tooltip!" [disabled]="disabled">
  <mat-icon>{{ icon }}</mat-icon>
  {{ label }}
</button>